import { connect, MapStateToProps } from 'react-redux';
import { isBannerVisible } from '@wix/da-shared-react/pkg/redux/sisuFunnel/selectors';
import { AppState } from '../../types/store';
import {
  getCurrentFeedType,
  getSearchPath,
  getSearchQuery,
} from '../../selectors/page';
import {
  getShowNetworkBarInSiteHeader,
  getSelectedNetworkBarItem,
} from '../../selectors/app';
import { Props } from './App';
import { getIsMobile } from '@wix/da-shared-react/pkg/publicSession/selectors';

type StateProps = Pick<
  Props,
  | 'environment'
  | 'sisuFunnelBannerVisible'
  | 'showNetworkBarInSiteHeader'
  | 'activeSiteHeaderItem'
  | 'disableBackToTop'
  | 'searchTerm'
  | 'searchPath'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({
    disableBackToTop:
      getIsMobile(state) && getCurrentFeedType(state) === 'posts',
    environment: state.environment.type,
    sisuFunnelBannerVisible: isBannerVisible(state),
    showNetworkBarInSiteHeader: getShowNetworkBarInSiteHeader(state),
    activeSiteHeaderItem: getSelectedNetworkBarItem(state) as string,
    searchTerm: getSearchQuery(state),
    searchPath: getSearchPath(state),
  });

export default connect(mapStateToProps);
